import React, { type FC } from 'react';
import { observer } from 'mobx-react-lite';
import { Space, Text } from '@g2u/ui-kit';
import { Divider } from 'antd';

import { type JsonDataItem, type WithOptionalDataTest } from 'types';
import { Details } from 'components';
import styles from './service-total.module.scss';

export namespace ServiceTotal {
  export type Props = {
    data: JsonDataItem;
    totalHours: number;
  } & WithOptionalDataTest;

  export const $: FC<Props> = observer((props) => {
    const { data, totalHours } = props;

    return (
      <div className={styles.serviceTotal}>
        <Divider className={styles.serviceTotal__divider} />
        <Text.$ strong size={Text.Size.LG}>
          Service Total
        </Text.$>
        <Space.$ direction={Space.Direction.Vertical} align={Space.Align.End}>
          <Details.$ columns>
            <Details.Item label={<Text.$ strong size={Text.Size.SM} type="secondary">Hours Total</Text.$>} value={<Text.$ strong size={Text.Size.MD} type="secondary">{`${totalHours} hours`}</Text.$>} />
            <Details.Item
              label={
                <Text.$ strong size={Text.Size.SM}>
                  Sub Total
                </Text.$>
              }
              value={
                <>
                  <Text.$ strong size={Text.Size.LG}>
                    ${data.subTotal}
                  </Text.$>{' '}
                  <Text.$ size={Text.Size.SM}>ex GST</Text.$>
                </>
              }
            />
            <Details.Item
              label={
                <Text.$ strong size={Text.Size.SM}>
                  GST
                </Text.$>
              }
              value={
                <Text.$ strong size={Text.Size.LG}>
                  ${data.gst}
                </Text.$>
              }
            />
            {data.discountTotal !== '0.00' && (
              <Details.Item
                label={
                  <Text.$ strong type="danger" size={Text.Size.SM}>
                    Discount
                  </Text.$>
                }
                value={
                  <>
                    <Text.$ strong type="danger" size={Text.Size.LG} className={styles.serviceTotal__discount}>
                      -${data.discountTotal}
                    </Text.$>{' '}
                    <Text.$ type="danger" size={Text.Size.SM}>
                      inc GST
                    </Text.$>
                  </>
                }
              />
            )}
            <Details.Item
              label={
                <Text.$ strong type="success" size={Text.Size.SM}>
                  Job Total
                </Text.$>
              }
              value={
                <>
                  <Text.$ strong type="success" size={Text.Size.LG}>
                    ${data.total}
                  </Text.$>{' '}
                  <Text.$ type="success" size={Text.Size.SM}>
                    inc GST
                  </Text.$>
                </>
              }
            />
          </Details.$>
        </Space.$>
      </div>
    );
  });
}
